import { render, staticRenderFns } from "./TransactionsHistoryFilters.vue?vue&type=template&id=22f0a2fd&scoped=true&"
import script from "./TransactionsHistoryFilters.vue?vue&type=script&lang=js&"
export * from "./TransactionsHistoryFilters.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsHistoryFilters.vue?vue&type=style&index=0&id=22f0a2fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f0a2fd",
  null
  
)

export default component.exports